import * as React from 'react';
import { MediaListItem } from './MediaListItem';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getItems, getItem, hasItems, Series } from './Model';
import { SeriesListContext } from './SeriesListContext';
import ActiveLastBreadcrumb from './Breadcrumbs';

const first = (array: Array<any>) => {
  if (array.length > 0) {
    return array[0];
  }
  return undefined;
}
export default function MediaList() {
  const params = useParams();
  const parent = getItem(params?.id ?? 's')!
  const [selectedIndex, setSelectedIndex] = React.useState(first(getItems(parent)) ?? "");
  const  navigate = useNavigate();

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    movieId: string,
  ) => {
    if (hasItems(getItem(movieId))) {
      navigate(`/${movieId}`, {state: { movieId }});
    }
    setSelectedIndex(movieId);
  };

  console.log(parent, getItems(parent) );
  const items = (getItems(parent) as Array<any>).filter((item:any) => item.id ?? false).map((item) => {
    return (<>
      <ListItemButton 
          selected={selectedIndex === item.id}
          onClick={(event) => handleListItemClick(event, item.id!)}
          sx={{justifyContent: 'space-between', display: 'flex'}}
        >
        <MediaListItem item={item} />
      </ListItemButton>
    </>)
  });

  return (
    <>
          <ActiveLastBreadcrumb />
        <SeriesListContext item={parent as Series}/>
        <List>
        {items}
        </List>
</>
  );
}